var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bottomLLB"}},[_c('div',{staticClass:"bottomLLBBox"},[_c('div',{staticClass:"top"},[_vm._v("企商办由河北企商办企业管理咨询有限公司运营，主要为企业提供一体化知识产权服务。")]),_c('div',{staticClass:"bottom"},[_vm._v("郑重提醒：我们无需验证码等相关信息。如需填写银行卡号、验证码等相关信息，切勿相信，谨防上当受骗！ ")])]),_c('div',{staticClass:"bottomFont"},[_vm._v("备案号:冀ICP备2025098197号-3")])])
}]

export { render, staticRenderFns }